import { Button, Form, Input, Space } from "antd";
import { useEffect } from "react";
import {
  useAddDepartmentMutation,
  useGetDepartmentDetailsQuery,
  useUpdateDepartmentMutation,
} from "../../../features/department/departmentApi";
import useError from "../../../hooks/useError";
import { toast } from "../../../lib/toast";
import { ModalComponentProps } from "../../../types";
import CustomModal from "../../ui/CustomModal";
import Loader from "../../ui/Loader";

export default function ManageDepartment({
  handleClose,
  type,
  data,
  ...rest
}: ModalComponentProps<string>) {
  const [form] = Form.useForm();
  const {
    isLoading: isDepartmentLoading,
    isError: isDepartmentDetailsError,
    error: departmentDetailsError,
    data: departmentDetails,
  } = useGetDepartmentDetailsQuery(data || "", {
    skip: !data && type !== "UPDATE",
  });
  const [addDepartment, { isLoading, isError, isSuccess, error }] =
    useAddDepartmentMutation();
  const [
    updateDepartment,
    {
      isLoading: isUpdateLoading,
      isError: isUpdateError,
      isSuccess: isUpdateSuccess,
      error: updateError,
    },
  ] = useUpdateDepartmentMutation();
  // error toast message
  useError(isError, error, "Department added fail");
  useError(isUpdateError, updateError, "Department updated fail");
  useError(
    isDepartmentDetailsError,
    departmentDetailsError,
    "Get department fail"
  );

  const onFinish = (values: unknown) => {
    if (type === "UPDATE" && data) {
      return updateDepartment({ body: values, id: data });
    }

    return addDepartment(values);
  };

  useEffect(() => {
    if (Object.keys(departmentDetails?.data || {}) && type === "UPDATE") {
      const department = departmentDetails?.data;

      form.setFieldsValue({
        name: department?.name,
        abbreviation: department?.abbreviation,
      });
    }
  }, [form, departmentDetails?.data, type]);

  // success toast message
  useEffect(() => {
    if (isSuccess) {
      toast("success", "Department added successfully");
      return handleClose();
    }
    if (isUpdateSuccess) {
      toast("success", "Department updated successfully");
      return handleClose();
    }
  }, [handleClose, isSuccess, isUpdateSuccess]);

  return (
    <CustomModal
      title={`${type === "UPDATE" ? "Update" : "Add New"} Department`}
      {...rest}
      handleClose={handleClose}
      width={460}
      footer={null}
    >
      <Form
        className="custom-form"
        layout="vertical"
        requiredMark="optional"
        size="large"
        onFinish={onFinish}
        form={form}
      >
        {isDepartmentLoading ? (
          <Loader />
        ) : (
          <>
            <Form.Item
              name="name"
              label="Department Name"
              className="mb-4"
              rules={[
                {
                  required: true,
                  message: "Please enter name",
                },
              ]}
            >
              <Input size="large" placeholder="Enter name" />
            </Form.Item>
            <Form.Item
              name="abbreviation"
              label="Abbreviation"
              className="mb-4"
            >
              <Input size="large" placeholder="Ex: HRM" />
            </Form.Item>
          </>
        )}

        <Space className="w-full mt-2" size={12}>
          <Button
            className="normal-dark-button modal-button"
            onClick={handleClose}
            size="middle"
            disabled={isLoading || isUpdateLoading}
          >
            Cancel
          </Button>
          <Button
            className="modal-button"
            type="primary"
            htmlType="submit"
            size="middle"
            loading={isLoading || isUpdateLoading}
            disabled={isDepartmentLoading}
          >
            {type === "UPDATE" ? "Update" : "Save"}
          </Button>
        </Space>
      </Form>
    </CustomModal>
  );
}
